export default __webpack_public_path__ + "static/media/1865.ff312b4c.png";